import { SalaryRuleRuleset } from "./salary-rule-ruleset";
import { User } from "./user";

export class SalaryRule {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    created_by_id!: number;
    created_by: User = new User();
    updated_by_id!: number;
    updated_by: User = new User();
    name!: string;
    rulesets!: SalaryRuleRuleset[]
}
